import { createUseStyles } from 'react-jss'

export default createUseStyles({
  container: {
    backgroundColor: 'var(--section__background__color)',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    width: '100%',
    position: 'absolute'
  },
  routesContainer: {
    backgroundColor: 'var(--section__background__color)',
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
    overflow: 'auto'
  }
})
